import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

import { isPositiveOrNegative } from 'src/components/dashboard/helper';

export const styles = {
  numberDifference:
    (comparisonDiff: number | null | undefined) =>
    (theme: Theme): SystemStyleObject<Theme> => {
      const positiveOrNegative = isPositiveOrNegative(comparisonDiff);

      return {
        color: positiveOrNegative
          ? positiveOrNegative > 0
            ? theme.colors.differencePositive
            : theme.colors.differenceNegative
          : theme.colors.differenceNeutral,
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',

        '& > svg': {
          float: 'left',
          my: '-0.25rem',
        },
      };
    },
};
